export default {
  path: 'baremetal/create',
  name: 'baremetal/create',
  component: () => import('@/views/dashboard/baremetal/create/create.vue'),
};
